<template>
    <v-ons-bottom-toolbar
        v-if="showFooter">
            <h2>{{ customerType }} Level</h2>
    </v-ons-bottom-toolbar>
</template>
<script>
import Utils from '../mixins/Utils'
import Module from '../mixins/Module'

export default {
    data () {
        return {

        }
    },

    mixins: [
        Utils,
        Module('customer'),
    ],

    props: ['showFooter'],

    watch: {
        showFooter(newVal) {
            if (!newVal) {
                _.map(document.getElementsByTagName('ons-page'), (onsPage) => {
                    onsPage.classList.remove('page-with-bottom-toolbar');
                })
            }
        }
    },

    computed: {
        customerType() {
            return _.get(this.customer, 'content.attributes.customer_type');
        }
    },

    methods: {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue